var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-chart-column-increasing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66667 9.91667V10.5M7 8.75V10.5M9.33333 7.58333V10.5",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.58333 1.45833V1.75C7.58333 3.39992 7.58333 4.22487 8.09591 4.73744C8.60848 5.25 9.43343 5.25 11.0833 5.25H11.375M11.6667 6.21653V8.16667C11.6667 10.3665 11.6667 11.4665 10.9832 12.1499C10.2999 12.8333 9.19987 12.8333 7 12.8333C4.80011 12.8333 3.70017 12.8333 3.01675 12.1499C2.33333 11.4665 2.33333 10.3665 2.33333 8.16667V5.51591C2.33333 3.62298 2.33333 2.67651 2.85021 2.03544C2.95463 1.90593 3.0726 1.78796 3.20211 1.68354C3.84318 1.16667 4.78964 1.16667 6.68255 1.16667C7.09415 1.16667 7.29989 1.16667 7.48837 1.23317C7.52757 1.247 7.56595 1.26292 7.60346 1.28085C7.78377 1.36707 7.92925 1.51258 8.22027 1.8036L10.9832 4.56658C11.3205 4.90379 11.489 5.07239 11.5779 5.28679C11.6667 5.50118 11.6667 5.73962 11.6667 6.21653Z",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileChart);
export default __webpack_public_path__ + "static/media/file-chart.2de964c5be690eb8dcb247a405bb44b6.svg";
export { ForwardRef as ReactComponent };